export const DeliveryMethod = {
  ESIGN: 'ESIGN',
  MAIL: 'MAIL',
};

export const MAILBOX_RULE_BUSINESS_DAYS = 3;

export const DELIVERY_METHOD_OPTIONS = [
  { value: DeliveryMethod.ESIGN, label: 'E-sign' },
  { value: DeliveryMethod.MAIL, label: 'Mail' },
];
